import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
import StringService from '~/utils/StringService';
import _ from 'lodash';

const MetadataService = function() {
  const _defaultDescription =
    'Security scanning of open source libraries with automated integration to build tools and code repos.';

  const setTitles = () => {
    // missing title
    // $state.$current.data.pageTitle = title;
    // $state.$current.data.metaTwitterTitle = title;
    // $state.$current.data.metaOGTitle = title;
  };
  const setDefaultDescriptions = () => {
    this.setDescriptions(
      'Security scanning of open source libraries with automated integration to build tools and code repos.'
    );
  };
  const setDescriptions = () => {
    // missing description
    // $state.$current.data.metaDescription = description;
    // $state.$current.data.metaOGDescription = description;
    // $state.$current.data.metaTwitterDescription = description;
  };
  const populateMetaURL = () => {
    // $state.$current.data.metaURL = $location.absUrl().split('#')[0].split('?')[0];
  };

  const createMetaURL = location => {
    if (!location) {
      return '';
    }

    return location.split('#')[0].split('?')[0];
  };

  const createComponentCatalogPageTitle = component => {
    const { libraryModel = {}, stats = {} } = component;
    const { name } = libraryModel;
    const { vulnCount } = stats;

    return `${vulnCount === 0 ? 'No ' : ''}Vulnerabilities found in the ${name} library`;
  };

  const createComponentCatalogPageDescription = component => {
    const { libraryModel = {}, stats = {} } = component;
    const { name = '', versions: componentVersions = [] } = libraryModel;
    const {
      highRiskInstanceCount,
      mediumRiskInstanceCount,
      lowRiskInstanceCount,
      noRiskInstanceCount,
      vulnCount,
    } = stats;

    const versions =
      componentVersions && componentVersions.filter(version => version.version !== 'HEAD');
    const versionCount = versions ? versions.length : '-';

    const versionsAffectedCount = _.sum([
      highRiskInstanceCount,
      mediumRiskInstanceCount,
      lowRiskInstanceCount,
    ]);
    const safeVersionsCount = noRiskInstanceCount !== undefined ? noRiskInstanceCount : '';
    const safeVersionsCountText =
      safeVersionsCount && safeVersionsCount > 0 ? noRiskInstanceCount : 'no';

    let riskMsg = '';

    if (highRiskInstanceCount > 0) {
      riskMsg = `high risk issues affecting ${highRiskInstanceCount} versions`;
    } else if (mediumRiskInstanceCount > 0) {
      riskMsg = `medium risk issues affecting ${mediumRiskInstanceCount} versions`;
    } else if (lowRiskInstanceCount > 0) {
      riskMsg = `low risk issues affecting ${lowRiskInstanceCount} versions`;
    }

    const riskMsgText = riskMsg ? ` including ${riskMsg}` : '';
    const versionsAffectedText =
      versionsAffectedCount > 0
        ? `There are ${safeVersionsCountText} safe versions to choose from out of ${versionCount} versions released.`
        : '';

    return `There ${vulnCount !== 1 ? 'are' : 'is'} ${vulnCount} vulnerabilit${
      vulnCount !== 1 ? 'ies' : 'y'
    } found in the ${name} library${riskMsgText}. ${versionsAffectedText}`;
  };

  const createComponentCatalogPageKeywords = component => {
    let keywords = '';

    if (!component) {
      keywords =
        'Veracode - Build software, safely. Veracode Software Composition Analysis help you secure your open-source code from hackers by creating a real-time inventory of your open-source components. We show you where they came from, who created them, and exactly what they are doing in their applications. We detail vulnerabilities that could be used by hackers to compromise applications and customer data and provide clear guidance on fixes.';
      return;
    }

    const { libraryModel = {} } = component;
    const { name = '', coordinate1 = '', coordinate2 = '' } = libraryModel;

    keywords = `${name} vulnerability,`;
    keywords = coordinate1 ? `${keywords}${coordinate1} vulnerability,` : keywords;
    keywords = coordinate2 ? `${keywords}${coordinate2} vulnerability,` : keywords;
    keywords = `${keywords}${name},`;
    keywords = coordinate1 ? `${keywords}${coordinate1},` : keywords;
    keywords = coordinate2 ? `${keywords}${coordinate2},` : keywords;
    keywords = `${keywords}opensource vulnerability, open source vulnerability, software composition analysis`;

    return keywords;
  };

  const generateCommonMetaProperties = (title, description, metaURL, metaKeywords) => {
    const meta = [
      { name: 'title', content: title },
      { name: 'description', content: description },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'keywords', content: metaKeywords },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: metaURL },
    ];

    return meta;
  };

  const generateComponentMeta = (component, location) => {
    if (!component) {
      return [];
    }

    const title = createComponentCatalogPageTitle(component);
    const description = createComponentCatalogPageDescription(component);
    const metaURL = createMetaURL(location);
    const metaKeywords = createComponentCatalogPageKeywords(component);
    const meta = generateCommonMetaProperties(title, description, metaURL, metaKeywords);

    return meta;
  };

  const createVulnerabilityCatalogPageTitle = (vuln, artifactComponents = []) => {
    const { title = '' } = vuln;

    const firstComponentName = artifactComponents[0] && artifactComponents[0].componentName;
    const otherComponentsCount = artifactComponents.length - 1;
    return `${title} Vulnerability in the ${firstComponentName} library ${
      otherComponentsCount > 0 ? `+ ${otherComponentsCount} More` : ''
    } | Veracode`;
  };

  const createVulnerabilityCatalogPageKeywords = (artifactComponents = []) => {
    const libraryNames = artifactComponents.map(component => component.componentName).join(', ');
    const libraryNamesFormatted = artifactComponents
      .map(component => `${component.componentName} vulnerability`)
      .join(', ');
    const commonKeywords = `vulnerability, opensource vulnerability, software composition analysis`;

    return `${libraryNamesFormatted}, ${libraryNames}, ${commonKeywords}`;
  };

  const createVulnerabilityCatalogPageDescription = (vuln, artifactComponents = []) => {
    const componentsNameAndCoords = artifactComponents.map(component => {
      const { componentName: name, coordOne: coordinate1, coordTwo: coordinate2 } = component;
      const maybeOnlyCoordinate1 = coordinate1 ? coordinate1 : '';
      const fullCoords =
        coordinate1 && coordinate2 ? `${coordinate1}, ${coordinate2}` : maybeOnlyCoordinate1;

      return `${name} (${fullCoords})`;
    });

    const overviewText = vuln && vuln.overview ? vuln.overview : '';

    const components = StringService.commaConjunctionJoinString(componentsNameAndCoords);
    return `${components}. ${overviewText}`;
  };

  const generateVulnerabilityCatalogMeta = (vuln, location, artifactComponents) => {
    if (!vuln) {
      return [];
    }
    const title = createVulnerabilityCatalogPageTitle(vuln, artifactComponents);
    const description = createVulnerabilityCatalogPageDescription(vuln, artifactComponents);
    const metaURL = createMetaURL(location);
    const metaKeywords = createVulnerabilityCatalogPageKeywords(artifactComponents);
    const meta = generateCommonMetaProperties(title, description, metaURL, metaKeywords);

    return meta;
  };

  const setComponentCatalogSEO = (component, specificPage) => {
    let title = this.createComponentCatalogPageTitle(component, specificPage),
      description = this.createComponentCatalogPageDescription(component);

    this.setTitles(title);
    this.setDescriptions(description);
    this.populateMetaURL();
  };

  const setVulnerabilityCatalogSEO = vuln => {
    let title = this.createVulnerabilityCatalogPageTitle(vuln),
      description = this.createVulnerabilityCatalogPageDescription(vuln);

    this.setTitles(title);
    this.setDescriptions(description);
    this.populateMetaURL();
  };

  const setHomePageSEO = () => {
    this.setTitles('Veracode SCA - Security for open-source code');
    this.setDefaultDescriptions();
    this.populateMetaURL();
  };

  const setCSOPageSEO = () => {
    this.setTitles('Open-source library security integrated with builds and code.');
    this.setDescriptions(
      'Veracode SCA secures your use of open source without slowing down your development teams.'
    );
    this.populateMetaURL();
  };

  const setRegistryExplorePageSEO = () => {
    this.setTitles(
      `Veracode ${
        SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.name
      } - Open-Source Libraries and Vulnerabilities`
    );
    this.setDescriptions(
      "Summary data of the world's open source libraries and their vulnerabilities, sortable by language."
    );
    this.populateMetaURL();
  };

  const generateRegistryExplorePageSEO = location => {
    const title = `Veracode ${
      SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.name
    } - Open-Source Libraries and Vulnerabilities`;
    const description =
      "Summary data of the world's open source libraries and their vulnerabilities, sortable by language.";
    const metaURL = createMetaURL(location);
    const meta = generateCommonMetaProperties(title, description, metaURL);

    return meta;
  };
  // maybe remove this, below?
  const setResearchPageSEO = () => {
    this.setTitles('Veracode SCA Community Researcher Program - Validating Vulnerabilities');
    this.setDescriptions(
      "Veracode's Software Composition Analysis Community Researcher Program is a community of the brightest security minds validating and documenting open source libraries vulnerabilities"
    );
    this.populateMetaURL();
  };

  const setFeaturesPageSEO = page => {
    const titles = {
        install: 'Open-source security integrated into your development tools',
        analyze: 'Understand your open-source libraries, licenses and vulnerabilities',
        eliminate: 'Veracode provides tools to identify vulnerabilities for your code',
        science: 'Veracode has the largest and most accurate vulnerability library available',
      },
      descriptions = {
        install:
          'Automated open source security integrated into your repo and build tools such as Github, Jenkins and Bitbucket.',
        analyze:
          'Veracode SCA provides a complete view of open-source libraries, their versions, licensing and security vulnerabilities.',
        eliminate:
          'Spend your time fixing vulnerabilities in use by discovering which vulnerabilities are actually being used in your code. And then fix them faster with our write-ups.',
        science:
          'Veracode SCA syncs millions of open-source libraries to build the smartest and most complete open source vulnerability data available.',
      };
    this.setTitles(titles[page]);
    this.setDescriptions(descriptions[page]);
    this.populateMetaURL();
  };

  const setProductTourPageSEO = page => {
    const titles = {
      overview: 'Product Tour | Overview',
      features: 'Product Tour | Features',
      integrations: 'Product Tour | Integrations',
      difference: 'Product Tour | We are different',
    };
    this.setTitles(titles[page]);
    this.setDefaultDescriptions();
    this.populateMetaURL();
  };
  const setDownloadsPageSEO = specificTool => {
    const descriptions = {
        scm:
          'Veracode SCA source code management server agent for GitHub, GitHub Enterprise, Atlassian Stash, BitBucket Server and Git.',
        console: 'Veracode SCA Terminal application for Apple OSX and Linux.',
        maven: 'Veracode SCA Maven plugin.',
        gradle: 'Veracode SCA Gradle plugin.',
        list: 'The latest and archived downloads of Veracode SCA software.', // for the main /downloads page
      },
      titles = {
        scm: 'Agent',
        console: 'Terminal Application',
        maven: 'Maven Plugin',
        gradle: 'Gradle Plugin',
      };

    // title is 'Downloads' for list page and 'Downloads | <specificTool>' for the other pages
    this.setTitles(
      'Downloads' + (specificTool && specificTool !== 'list' ? ' | ' + titles[specificTool] : '')
    );
    this.setDescriptions(descriptions[specificTool]);
    this.populateMetaURL();
  };
  const setLegalPageSEO = () => {
    this.setTitles("Veracode's legal terms and conditions");
    this.setDescriptions("Veracode's legal terms and conditions.");
    this.populateMetaURL();
  };
  const setLoginPageSEO = page => {
    const titles = {
        login: 'Login | Veracode',
        signup: 'Sign Up | Veracode',
        forgotUser: 'Forgot Username | Veracode',
        forgotPass: 'Forgot Password | Veracode',
        twoFactor: 'Two Factor | Veracode',
      },
      descriptions = {
        login: 'Log in to Veracode',
        signup: 'Sign up for Veracode',
        forgotUser: "Enter your email, and we'll send your Veracode username",
        forgotPass: 'Reset the password for your Veracode account',
        twoFactor: 'Enter your two-factor authentication code.',
      };
    this.setTitles(titles[page]);
    this.setDescriptions(descriptions[page]);
    this.populateMetaURL();
  };
  const setAboutUsPageSEO = () => {
    this.setTitles('Veracode - About Us');
    this.setDescriptions("The team securing the world's open source libraries for developers.");
    this.populateMetaURL();
  };
  const setContactUsPageSEO = () => {
    this.setTitles('Veracode - Contact Us');
    this.setDescriptions('Contact information for Veracode');
    this.populateMetaURL();
  };
  const setMediaPageSEO = () => {
    this.setTitles('Media | Veracode');
    this.setDefaultDescriptions();
    this.populateMetaURL();
  };
  const setPressPageSEO = () => {
    this.setTitles('Press | Veracode');
    this.setDefaultDescriptions();
    this.populateMetaURL();
  };
  const setSearchPageSEO = () => {
    this.setTitles('Search | Veracode');
    this.setDefaultDescriptions();
    this.populateMetaURL();
  };

  const generateSearchPageSEO = location => {
    const title = 'Search | Veracode';
    const description = _defaultDescription;
    const metaURL = createMetaURL(location);
    const meta = generateCommonMetaProperties(title, description, metaURL);

    return meta;
  };

  return {
    setTitles,
    setDefaultDescriptions,
    setDescriptions,
    populateMetaURL,
    createMetaURL,
    createComponentCatalogPageTitle,
    createComponentCatalogPageDescription,
    generateComponentMeta,
    createVulnerabilityCatalogPageTitle,
    createVulnerabilityCatalogPageDescription,
    generateVulnerabilityCatalogMeta,
    setComponentCatalogSEO,
    setVulnerabilityCatalogSEO,
    setHomePageSEO,
    setCSOPageSEO,
    setResearchPageSEO,
    setRegistryExplorePageSEO,
    setFeaturesPageSEO,
    setProductTourPageSEO,
    setDownloadsPageSEO,
    setLegalPageSEO,
    setLoginPageSEO,
    setAboutUsPageSEO,
    setContactUsPageSEO,
    setMediaPageSEO,
    setPressPageSEO,
    setSearchPageSEO,
    generateRegistryExplorePageSEO,
    generateSearchPageSEO,
  };
};

export default new MetadataService();
